import { getDisplayFriendlySize } from "client_legacy/Documents/fileExtensions";
import { localize } from "client_legacy/ndaw/culture";
import { InputValidationResult, InputValidationResultKind } from "../input";
import { ValidationRuleTriggers } from "./triggers";
import { Base64FileUriUploadWithMetadataModel } from "client/Misc/commonTypes";
import { getFileMetadata } from "client/Misc/utils";

export class HasMaxSizeRule extends ValidationRuleTriggers<OptionalModel<Base64FileUriUploadWithMetadataModel | null>> {
	private readonly _maxSize: number;
	private readonly _alternativeMessage: string | undefined;

	constructor (maxSize: number, alternativeMessage?: string) {
		super();
		this._maxSize = maxSize;
		this._alternativeMessage = alternativeMessage;
	}

	public validate(
		value: OptionalModel<Base64FileUriUploadWithMetadataModel | null>
	): InputValidationResult {
		if (!value.isSet || value.value === null) {
			return { kind: InputValidationResultKind.Valid };
		}

		const {
			size
		} = getFileMetadata(value.value);

		if (size > this._maxSize) {
			return {
				kind: InputValidationResultKind.Invalid,
				errorMessage: this._alternativeMessage
					|| localize("_MaxSizeIs").replace(
						"{0}",
						getDisplayFriendlySize(this._maxSize)
					)
			};
		}

		return { kind: InputValidationResultKind.Valid };
	}
}

export class IsSupportedFileType extends ValidationRuleTriggers<OptionalModel<Base64FileUriUploadWithMetadataModel | null>> {
	private readonly _supportedFileTypes: readonly string[];
	private readonly _alternativeMessage: string | undefined;

	constructor (supportedFileTypes: readonly string[], alternativeMessage?: string) {
		super();
		this._supportedFileTypes = supportedFileTypes;
		this._alternativeMessage = alternativeMessage;
	}

	public validate(value: OptionalModel<Base64FileUriUploadWithMetadataModel | null>): InputValidationResult {
		if (!value.isSet || value.value === null) {
			return { kind: InputValidationResultKind.Valid };
		}

		const {
			mimeType
		} = getFileMetadata(value.value);

		if (this._supportedFileTypes.indexOf(mimeType) === -1) {
			return {
				kind: InputValidationResultKind.Invalid,
				errorMessage: this._alternativeMessage || localize("_FileTypeNotSupported")
			};
		}

		return { kind: InputValidationResultKind.Valid };
	}
}